import axios from 'axios';
import { makeOrderBy } from '../../../helpers/utils/query.utils';
import { getUriParams } from '../../../helpers/utils/utils';
import { tiposHistoricos } from '../../../types/tiposHistoricoTypes';
import { CORE, gateway, gatewayShortJson } from '../../api';

export function buscarProcessoComFiltrosSimples(filtro, page, size, ordenacao) {
  const queryParams = getUriParams({ ...filtro, page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(`${CORE}/processos?${queryParams}${orderBy}`);
}

export function buscarProcessoComFiltrosAvancada(
  filtro,
  page,
  size,
  ordenacao
) {
  const queryParams = getUriParams({ ...filtro, page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(`${CORE}/processos/avancada?${queryParams}${orderBy}`);
}

export function buscarProcessoComFiltrosEspecial(
  filtro,
  page,
  size,
  ordenacao
) {
  const queryParams = getUriParams({ ...filtro, page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(`${CORE}/processos/especial?${queryParams}${orderBy}`);
}

export function pesquisarProcessosProximoVencimento(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(
    `${CORE}/processos/processosProximoVencimento?${queryParams}${orderBy}`
  );
}

export function buscarIdsProcessosProximoVencimento() {
  return gateway.get(`${CORE}/processos/processosProximoVencimento/ids`);
}

export function pesquisarProcessosComPrazoVencido(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(
    `${CORE}/processos/processosComPrazoVencido?${queryParams}${orderBy}`
  );
}

export function pesquisarProcessosAVencer(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(
    `${CORE}/processos/processosAVencer?${queryParams}${orderBy}`
  );
}

export function pesquisarProcessosNovos(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(
    `${CORE}/processos/processosNovos?${queryParams}${orderBy}`
  );
}

export function pesquisarProcessosAguardandoRequisicao(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(
    `${CORE}/processos/processosAguardandoRequisicao?${queryParams}${orderBy}`
  );
}

export function pesquisarMeusProcessos(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(
    `${CORE}/processos/meusProcessos?${queryParams}${orderBy}`
  );
}

export function buscarIdsProcessosComPrazoVencido() {
  return gateway.get(`${CORE}/processos/processosComPrazoVencido/ids`);
}

export function buscarIdsProcessosAVencer() {
  return gateway.get(`${CORE}/processos/processosAVencer/ids`);
}

export function buscarIdsProcessosNovos() {
  return gateway.get(`${CORE}/processos/processosNovos/ids`);
}

export function buscarIdsProcessosAguardandoRequisicao() {
  return gateway.get(`${CORE}/processos/processosAguardandoRequisicao/ids`);
}

export function buscarIdsMeusProcessos() {
  return gateway.get(`${CORE}/processos/meusProcessos/ids`);
}

export function pesquisarProcessosComNotificacoes(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(`${CORE}/processos/notificacoes?${queryParams}${orderBy}`);
}

export function buscarIdsProcessosComNotificacoes() {
  return gateway.get(`${CORE}/processos/notificacoes/ids`);
}

export function pesquisarProcessosComAutorizacoes(page, size, ordenacao) {
  const queryParams = getUriParams({ page, size });
  const orderBy = makeOrderBy(ordenacao);
  return gateway.get(`${CORE}/processos/autorizacoes?${queryParams}${orderBy}`);
}

export function buscarIdsProcessosComAutorizacoes() {
  return gateway.get(`${CORE}/processos/autorizacoes/ids`);
}

export function buscarIdsProcessos(filtro, tipoPesquisa) {
  const queryParams = getUriParams(filtro);
  const tipoPesquisaParam = getUriParams({ tipoPesquisa });
  return gateway.get(
    `${CORE}/processos/ids?${queryParams}&${tipoPesquisaParam}`
  );
}

export function buscarIdsAvancadoProcessos(filtro, tipoPesquisa) {
  const queryParams = getUriParams(filtro);
  const tipoPesquisaParam = getUriParams({ tipoPesquisa });
  return gateway.get(
    `${CORE}/processos/ids-avancado?${queryParams}&${tipoPesquisaParam}`
  );
}

export function validarQuantidadeProcessosSelecionadoService(
  quantidadeSelecionada
) {
  return gatewayShortJson.get(
    `${CORE}/processos/${quantidadeSelecionada}/qtdSelecionada`
  );
}

export function updateTipoExibicaoHistorico(
  idProcesso,
  idProcessoHistorico,
  tipoExibicao
) {
  return gateway.put(
    `${CORE}/processos/${idProcesso}/historicos/${idProcessoHistorico}/tipo-exibicao/${tipoExibicao}`
  );
}

export function buscarHistoricoProcesso(
  numeroProcesso,
  sorted = [],
  queryParams
) {
  const getQueryParam = () => {
    if (queryParams) {
      return `&${getUriParams(queryParams)}`;
    }
    return '';
  };

  const sortedQuery = sorted.reduce((obj, sort) => `${obj}&sort=${sort}`, '');

  return gateway.get(
    `${CORE}/processos/${numeroProcesso}/historicos?${sortedQuery}${getQueryParam()}`
  );
}

export function findInformacoesAdicionaisInpescaoProcessoService(
  idProcesso,
  requisicoesUsuarioTemPermissao = []
) {
  const queryParams = requisicoesUsuarioTemPermissao.reduce(
    (prev, requisicao) => {
      if (prev === '') {
        return `?idRequisicaoUsuario=${requisicao}`;
      }
      return `${prev}&idRequisicaoUsuario=${requisicao}`;
    },
    ''
  );
  return gateway.get(`${CORE}/processos/${idProcesso}/inspecao${queryParams}`);
}

export function findAutoresHistoricosService(idProcesso) {
  return gatewayShortJson.get(
    `${CORE}/processos/${idProcesso}/autores-historicos`
  );
}

export function buscarUltimoProcessoHistorico(
  idProcesso,
  tipos = [tiposHistoricos.RELATORIO.value]
) {
  const tiposQueryParam = tipos.reduce((acc, tipo) => {
    if (acc.length === 0) {
      return `?tipoHistorico=${tipo}`;
    }
    return `${acc}&tipoHistorico=${tipo}`;
  }, '');
  return gateway.get(
    `${CORE}/processos/${idProcesso}/processo-historico${tiposQueryParam}`
  );
}

export function buscarIsUsuarioAssistente() {
  return gateway.get(`${CORE}/processos/isUsuarioAssistente`);
}

export function findTiposHistoricosProcessoService(idsTipoHistorico) {
  let queryParam = '';
  if (idsTipoHistorico) {
    queryParam = `&${getUriParams({ tipoHistoricos: idsTipoHistorico })}`;
  }

  return gatewayShortJson.get(`${CORE}/processos/tipo-historicos${queryParam}`);
}

export function inserirNovoHistorico(idProcesso, idTipoHistorico, texto) {
  return gateway.post(`${CORE}/processos/historico`, {
    idProcesso,
    idTipoHistorico,
    texto,
  });
}

export function inserirNovoAnotacao(
  idProcesso,
  idTipoHistorico,
  texto,
  tipoProcessoContatoSelecionado,
  ddd,
  telefone,
  nomeContatoRecado
) {
  return gateway.post(`${CORE}/processos/historico/anotacao`, {
    idProcesso,
    idTipoHistorico,
    texto,
    idTipoProcessoContatoSelecionado: tipoProcessoContatoSelecionado,
    ddd,
    telefone,
    nomeContatoRecado,
  });
}

export function buscarTipoProcessoContatos() {
  return gateway.post(`${CORE}/processos/tipo-processo-contato`);
}

export function getTiposAgendamentoProcessoService() {
  return gatewayShortJson.get(`${CORE}/processos/tipo-agendamentos`);
}

export function getUsuariosNegociadoresProcessoService() {
  return gatewayShortJson.get(`${CORE}/processos/buscar-negociadores`);
}
export function buscarAcompanhamentoDoProcessoService(idProcesso) {
  const params = getUriParams({ idProcesso });
  return gateway.get(`${CORE}/processos/acompanhamento-processo?${params}`);
}

export function atualizarEndossanteDoProcessoService(idProcesso, endossante) {
  const params = getUriParams({ endossante });
  return gateway.put(`${CORE}/processos/${idProcesso}/endossante?${params}`);
}

export function buscarAgendamentoProcessoService(idProcesso) {
  return gateway.get(`${CORE}/processos/${idProcesso}/agendamento`);
}

export function agendarCompromissoProcessoSerivce(agendamentoCompromisso) {
  return gateway.post(`${CORE}/processos/agendamento`, agendamentoCompromisso);
}

export function excluirAgendamentoCompromissoProcessoService(idProcesso) {
  return gateway.delete(`${CORE}/processos/${idProcesso}/agendamento`);
}

export function alterarExistirCobrancaJudicialDoProcessoService(
  idProcesso,
  ajuizarProcesso
) {
  const params = getUriParams({ idProcesso, ajuizarProcesso });
  return gateway.put(`${CORE}/processos/processo-ajuizado?${params}`);
}

export function alterarProtegerCodigoConsumidorDoProcessoService(
  idProcesso,
  protegerCodigoConsumidor
) {
  const params = getUriParams({ idProcesso, protegerCodigoConsumidor });
  return gateway.put(`${CORE}/processos/proteger-codigo-consumidor?${params}`);
}

export function alterarIncluirNaProducaoProcessoService(
  idProcesso,
  incluirNaProducao
) {
  const params = getUriParams({ idProcesso, incluirNaProducao });
  return gateway.put(
    `${CORE}/processos/alterar-status-producao-processo?${params}`
  );
}

export function alterarPermitirCobrancaPresencialService(
  idProcesso,
  permitirCobrancaPresencial
) {
  const params = getUriParams({
    idProcesso,
    permitirCobrancaPresencial: !permitirCobrancaPresencial,
  });
  return gateway.put(
    `${CORE}/processos/permitir-cobranca-presencial?${params}`
  );
}

export function enviarClienteEmailProcessoService(data, fases) {
  return gateway.post(`${CORE}/processos/cliente-email?fases=${fases}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function buscarClienteEmailProcessoService(idProcesso) {
  return gateway.get(`${CORE}/processos/${idProcesso}/email-cliente`);
}

export function buscarCadastroCliente(idProcesso) {
  return gateway.get(`${CORE}/processos/${idProcesso}/clientes`);
}

export function buscarWarningsDevedorProcesso(idProcesso) {
  return gateway.get(`${CORE}/processos/${idProcesso}/devedor-warnings`);
}

export function buscarKeyChatGPT() {
  return gateway.get(`${CORE}/gpt/buscar-key`);
}

export function melhorarTextService(content, apiKey) {
  const headers = {
    Authorization: `Bearer ${apiKey.data}`,
    ContentType: 'application/json',
  };
  const requestBody = {
    model: 'gpt-3.5-turbo',
    messages: [
      {
        role: 'user',
        content,
      },
    ],
    temperature: 0.8,
  };

  const response = axios.post(
    'https://api.openai.com/v1/chat/completions',
    requestBody,
    {
      headers,
    }
  );

  return response;
}

export function buscarFasesAndInfoAtuaisProcessos(idsProcessos) {
  return gateway.post(`${CORE}/processos/get-fases-atuais-info`, idsProcessos);
}

export function buscarNegociadoresHabilitadosProcesso(idProcesso) {
  return gateway.get(
    `${CORE}/processos/${idProcesso}/negociadores-habilitados`
  );
}

export function buscarNegociadorAtualProcesso(idProcesso) {
  return gateway.get(`${CORE}/processos/${idProcesso}/negociador-atual`);
}

export function submitTrocarNegociadorAtualProcesso(
  idProcesso,
  novoNegociadorId
) {
  return gateway.put(
    `${CORE}/processos/${idProcesso}/novo-negociador/${novoNegociadorId}`
  );
}

export function buscarDevedorGrupo(idDevedor, idDevedorAtual) {
  return gateway.get(
    `${CORE}/processos/${idDevedorAtual}/devedor-associado/${idDevedor}`
  );
}

export function getTiposTituloAgendamentoProcessoService() {
  return gatewayShortJson.get(`${CORE}/processos/titulo-compromisso`);
}

export function salvarReenvioWhatsapp(
  idProcesso,
  idFaseAtual,
  statusContatoDefinition
) {
  const params = getUriParams({ idFaseAtual, statusContatoDefinition });
  return gateway.post(
    `${CORE}/processos/reenvio-whatsapp/${idProcesso}?${params}`
  );
}

export function buscarEmailsProcesso(idProcesso) {
  return gateway.get(`${CORE}/processos/buscar-emails/${idProcesso}`);
}

export function registrarEmailsProcesso(idProcesso, texto) {
  const params = getUriParams({ texto });
  return gateway.post(
    `${CORE}/processos/registro-email/${idProcesso}?${params}`
  );
}
